import { API_ENDPOINT } from 'env'

export const deletarDivisaoSetor = async ({ id }) => {
  const storageData = localStorage.getItem('state')
  const parsed = JSON.parse(storageData)
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${parsed.auth.token}`,
    },
  }
  const res = await fetch(`${API_ENDPOINT}/divisoesSetores/${id}`, options)
  const text = await res.text()
  let data
  try {
    data = text ? JSON.parse(text) : null
  } catch {
    data = text
  }
  if (!res.ok) {
    const error = new Error('Erro ao deletar divisão/setor')
    error.status = res.status
    error.data = data
    throw error
  }

  return data
}

export const listarDivisoesSetores = async empresaId => {
  const storageData = localStorage.getItem('state')
  const parsed = JSON.parse(storageData)
  const response = await fetch(`${API_ENDPOINT}/divisoesSetores?empresaId=${empresaId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${parsed.auth.token}`,
    },
  })

  if (!response.ok) {
    throw new Error('Erro ao listar divisões e setores')
  }

  return await response.json()
}
